export enum BoosterType {
  BOOSTER_PLAYCOIN = 'BOOSTER_PLAYCOIN',
  BOOSTER_XP = 'BOOSTER_XP',
}

export enum BoosterSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
